/**
 * Right to left, a written "→" points the wrong way (2026-10-28): "1 Jan → 5 Jan", "PR → PO", "Review →"
 * read right to left, so the arrow must point left. The glyph is not one the bidi algorithm mirrors
 * and no stylesheet can flip a character inside text, so in the Arabic interface every text node
 * carrying one is rewritten as it appears — whether it came from a translation or straight from JSX.
 * Inputs and anything marked `dir="ltr"` (the map, code) are left alone.
 */
const SKIP = new Set(["INPUT", "TEXTAREA", "SCRIPT", "STYLE", "CODE", "PRE"]);

function fix(node: Node) {
  if (node.nodeType === Node.TEXT_NODE) {
    const text = node.nodeValue;
    if (!text || !text.includes("→")) return;
    const parent = node.parentElement;
    if (!parent || SKIP.has(parent.tagName) || parent.closest("[dir='ltr']")) return;
    node.nodeValue = text.replace(/→/g, "←");
    return;
  }
  if (node.nodeType === Node.ELEMENT_NODE) {
    if (SKIP.has((node as Element).tagName)) return;
    const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
    for (let n = walker.nextNode(); n; n = walker.nextNode()) fix(n);
  }
}

export function mirrorArrowsRightToLeft(): void {
  if (typeof MutationObserver === "undefined") return;
  const start = () => {
    fix(document.body);
    new MutationObserver((records) => {
      for (const r of records) {
        if (r.type === "characterData") fix(r.target);
        else r.addedNodes.forEach(fix);
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.body) start();
  else document.addEventListener("DOMContentLoaded", start, { once: true });
}
